var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._g({staticClass:"expandable",class:{ 'expandable--open': _vm.isOpen },style:({ transitionDuration: (_vm.transitionTime + "ms") })},_vm.$listeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }